// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"015ca477","256":"c72152f2","389":"22e824c7","453":"ed5f8288","455":"fbb9d860","534":"20f4e553","748":"4e52a36b","840":"336c6076","850":"196c3baf","977":"81f2a5a2","991":"b6a440fd","994":"962cbb04"}[chunkId] + ".chunk.js";
};